import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import Warning from "@/views/warning/components/WarningWrapper.vue";
import { COMP_FIELD } from "@/app-data/warning/warning";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompetitorWarning',
  setup(__props) {

const categoryField = computed(() => COMP_FIELD);

return { __sfc: true,categoryField, Warning }
}

})